/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { CoreConfigService } from '@xbaht/ui/core/services';

@Component({
  selector: 'xbaht-vertical-layout',
  templateUrl: './vertical-layout.component.html',
  styleUrl: './vertical-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class VerticalLayoutComponent implements OnInit, OnDestroy {
  public coreConfig: any;

  private _unsubscribe: Subject<void>;

  constructor(
    private _coreConfigService: CoreConfigService,
    private _elementRef: ElementRef
  ) {
    this._unsubscribe = new Subject();
  }

  ngOnInit(): void {
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config: any) => {
        this.coreConfig = config;
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
